export const FETCH_LIST_TRACKING_ANALYSIS = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING_ANALYSIS";
export const FETCH_LIST_TRACKING_ANALYSIS_SUCCESS = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING_ANALYSIS_SUCCESS";
export const FETCH_LIST_TRACKING_ANALYSIS_FAILED = "[TRACKING_MANAGEMENT] FETCH_LIST_TRACKING_ANALYSIS_FAILED";
